module.exports = __webpack_public_path__ + "img/icon-arrow-down.9a27f6a6.svg";